import { z } from "zod";

const CommonErrorResponseSchema = z.object({
  result: z.literal(false),
  errorCode: z.number().optional(),
  errorMessage: z.string().optional(),
  error: z.string().optional(),
});

export type CommonErrorResponse = z.infer<typeof CommonErrorResponseSchema>;

export const createCommonApiResponseSchema = <
  Shape extends z.ZodRawShape,
  UnknownKeys extends z.UnknownKeysParam = "strip",
  Catchall extends z.ZodTypeAny = z.ZodTypeAny,
>(
  schema: z.ZodObject<Shape, UnknownKeys, Catchall>
) =>
  z.discriminatedUnion("result", [
    CommonErrorResponseSchema,
    schema.extend({ result: z.literal(true) }),
  ]);

export const isCommonErrorResponse = (
  response: unknown
): response is CommonErrorResponse =>
  typeof response === "object" &&
  response !== null &&
  "result" in response &&
  response.result === false;
